import { render } from "./ClientProposalForm.vue?vue&type=template&id=2de3b6dd&scoped=true"
import script from "./ClientProposalForm.vue?vue&type=script&lang=js"
export * from "./ClientProposalForm.vue?vue&type=script&lang=js"

import "./ClientProposalForm.vue?vue&type=style&index=0&id=2de3b6dd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de3b6dd"]])

export default __exports__